export function getBaseApi() {
  return 'https://mock-api.dynastynerds.com';
  // return 'http://192.168.1.199:4001/api';
}
